module.exports = __webpack_public_path__ + "img/chatbot_apps.e07a3ed4.jpg";